module.exports = __webpack_public_path__ + "img/kosovo.3e5039f.webp";